<div class="container">
    <div class="row">
        <div class="col-md-6">
            <div class="card shadow mb-4 bg-white rounded">
                <ngx-gallery [options]="galleryOptions" [images]="nccImages"></ngx-gallery>
                <h2>NCC</h2>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card shadow mb-4 bg-white rounded">
                <ngx-gallery [options]="galleryOptions" [images]="mentorImages"></ngx-gallery>
                <h2>Mentor</h2>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card shadow mb-4 bg-white rounded">
                <ngx-gallery [options]="galleryOptions" [images]="opensourceImages"></ngx-gallery>
                <h2>Opensource</h2>
            </div>
        </div>
        <div class="col-md-6">
            <div class="card shadow mb-4 bg-white rounded">
                <ngx-gallery [options]="galleryOptions" [images]="eventsImages"></ngx-gallery>
                <h2>Events</h2>
            </div>
        </div>
    </div>
</div>